module.exports = __webpack_public_path__ + "img/lottery.12067ccd.jpg";